import { styled } from '@spazious/dollhouse-theme';

import { Typography } from '../index.js';

export interface ChoiceButtonProps
  extends Omit<React.HTMLAttributes<HTMLLabelElement>, 'onChange'> {
  name: string;
  option: { label: string; value: string };
  checked: boolean;
  onChange: (lang: string) => void;
}

const ChoiceButtonContainer = styled.label<{ checked: boolean }>`
  display: block;
  position: relative;
  cursor: pointer;

  border-radius: var(--spacing-padding);
  padding: calc(var(--spacing-padding) * 1.5);
  min-width: 150px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: ${({ checked }) =>
    checked ? '1px solid var(--spz-sys-color-on-surface-variant)' : 'none'};

  &:hover {
    background-color: var(--spz-sys-color-surface-container-low);
    color: var(--spz-sys-color-on-surface);
  }
`;

const InputChoice = styled.input`
  background-color: ${({ checked }) => (checked ? 'red' : 'white')};
  /* Hide the browser's default radio button */
  position: absolute;
  opacity: 0;
  cursor: pointer;
`;

export const ChoiceButton: React.FC<ChoiceButtonProps> = ({
  name,
  option,
  checked,
  onChange,
  ...restProps
}) => {
  return (
    <ChoiceButtonContainer checked={checked} {...restProps}>
      <Typography>{option.label}</Typography>
      <InputChoice
        name={name}
        type="radio"
        value={option.value}
        onChange={(e) => onChange(e.target.value)}
      />
    </ChoiceButtonContainer>
  );
};
